import {charcoal} from '../sass/base/_exports.sass';

export const GiftboxIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 45;
  const height = 39;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5 0.500012C29.9046 0.499845 31.2844 0.869476 32.5008 1.57174C33.7172 2.274 34.7273 3.28415 35.4295 4.5006C36.1317 5.71705 36.5012 7.09694 36.5009 8.50151C36.5007 9.90608 36.1306 11.2858 35.428 12.502L44.5 12.5V16.5H40.5V36.5C40.5 37.0304 40.2893 37.5392 39.9142 37.9142C39.5391 38.2893 39.0304 38.5 38.5 38.5H6.5C5.96957 38.5 5.46086 38.2893 5.08579 37.9142C4.71071 37.5392 4.5 37.0304 4.5 36.5V16.5H0.5V12.5L9.572 12.502C8.57973 10.7838 8.26138 8.75813 8.67877 6.81836C9.09615 4.87859 10.2195 3.16315 11.8307 2.00512C13.4418 0.847086 15.4259 0.329112 17.3975 0.55177C19.3691 0.774428 21.1877 1.72183 22.5 3.21001C23.2492 2.35678 24.1721 1.67356 25.2069 1.20617C26.2418 0.738777 27.3645 0.498012 28.5 0.500012ZM20.5 16.5H8.5V34.5H20.5V16.5ZM36.5 16.5H24.5V34.5H36.5V16.5ZM16.5 4.50001C15.462 4.49537 14.4629 4.89439 13.7137 5.61277C12.9645 6.33115 12.5239 7.31264 12.4849 8.34989C12.446 9.38714 12.8118 10.3989 13.505 11.1714C14.1982 11.944 15.1646 12.4168 16.2 12.49L16.5 12.5H20.5V8.50001C20.5 7.54413 20.1578 6.61984 19.5352 5.89453C18.9126 5.16921 18.0508 4.69083 17.106 4.54601L16.798 4.51001L16.5 4.50001ZM28.5 4.50001C27.4908 4.49969 26.5189 4.88083 25.7789 5.56701C25.0389 6.25319 24.5857 7.1937 24.51 8.20001L24.5 8.50001V12.5H28.5C29.5092 12.5003 30.4811 12.1192 31.2211 11.433C31.9611 10.7468 32.4143 9.80632 32.49 8.80001L32.5 8.50001C32.5 7.43915 32.0786 6.42173 31.3284 5.67159C30.5783 4.92144 29.5609 4.50001 28.5 4.50001Z"
        fill={color}
      />
    </svg>
  );
};
